import React from 'react';
import { LiveRegion as UILiveRegion } from '../ui/accessibility/live-region';

export function LiveRegion() {
  return (
    <div className="sr-only" aria-live="polite" aria-atomic="true" id="live-region">
      {/* This serves as the main live region for the app */}
    </div>
  );
}